"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Cross = _interopRequireDefault(require("../images/Cross.svg"));

var _weiterRot = _interopRequireDefault(require("../images/weiterRot.svg"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DislikeAnimation = function DislikeAnimation(_ref) {
  var _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show;
  var className = show ? 'startAnimation' : 'stopped';

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return show ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "".concat(_styleModule.default.dislike, " ").concat(show ? _styleModule.default.display : _styleModule.default.hidden),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_styleModule.default.container, " ").concat(_styleModule.default[className]),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _Cross.default,
          alt: "",
          className: _styleModule.default.symbol
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_styleModule.default.textContainer, " ").concat(_styleModule.default[className]),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Container.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _styleModule.default.title,
          children: t('pc-matching:Animation.Dislike.title')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _styleModule.default.description,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: t('pc-matching:Animation.Dislike.text1')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: t('pc-matching:Animation.Dislike.text2')
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _weiterRot.default,
          alt: "",
          className: _styleModule.default.symbolNext
        })]
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};

var _default = /*#__PURE__*/(0, _react.memo)(DislikeAnimation);

exports.default = _default;